import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function ListagemConteudosFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing[6],
      }}
    >
      {Array.from({ length: 6 }).map((item, index) => (
        <Skeleton
          key={`${item}_${index}`}
          style={{
            height: 311,
            width: theme.tamanhoCartaz.width['medio'],
          }}
        />
      ))}
    </div>
  );
}
